import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { SpinnerService } from '../../services/spinner.service';
import { SnackbarService } from '../../services/snackbar.service';
import {
  GestoresResiduosDTO,
  GestoresResiduosControllerService,
  GestionResiduosFilterDTO,
  AcuerdoIndirectoControllerService,
  AcuerdoIndirectoCreatePayloadDTO,
} from 'api-rest';
import { ValidateService } from '../../services/validate.service';

@Component({
  selector: 'managers-agreements-indirect-agreement-dialog',
  templateUrl: './indirect-agreement-dialog.component.html',
  styleUrls: ['./indirect-agreement-dialog.component.scss'],
})
export class IndirectAgreementDialogComponent implements OnInit {
  dataForm: FormGroup;
  gestoresArray: GestoresResiduosDTO[] = [];
  searchDone: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<IndirectAgreementDialogComponent>,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private gestoresResiduosService: GestoresResiduosControllerService,
    private acuerdoIndirectoService: AcuerdoIndirectoControllerService,
    private validateSrv: ValidateService,
  ) {
    this.dataForm = this.formBuilder.group({
      documento: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, this.documentoValidator()]) },
      ],
      gestor: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      razonSocial: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(150)]) },
      ],
    });
  }

  ngOnInit(): void {
  }

  private detectarTipoDocumento(value: string): string | null {
    const doc = value.toUpperCase();
    const matches = (pattern: string) => new RegExp(`^(${pattern})$`).test(doc);
    if (matches(this.validateSrv.dniPattern)) {
      return 'DNI';
    }
    if (matches(this.validateSrv.niePattern)) {
      return 'NIE';
    }
    if (matches(this.validateSrv.nifPattern)) {
      return 'NIF';
    }
    return null;
  }

  documentoValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      return this.detectarTipoDocumento(value) ? null : { invalidFormat: true };
    };
  }

  canBuscarGestores(): boolean {
    const documento = this.dataForm.get('documento');
    return !!documento?.value && !documento?.invalid;
  }

  buscarGestores(): void {
     const documento = this.dataForm.get('documento')?.value;
    // if (!documento) {
    //   this.snackBarSrv.showSnackBar('Introduce un documento para buscar', 'error');
    //   return;
    // }

    // const filter: GestionResiduosFilterDTO = {
    //   codigoDocumento: documento.trim().toUpperCase(),
    //   gestorResiduos: true,
    // };

    // this.spinnerSrv.loadingShow();
    // this.gestoresResiduosService
    //   .findAll8(filter, { page: 0, size: 100, sort: [] })
    //   .subscribe({
    //     next: (data: any) => {
    //       this.spinnerSrv.loadingHide();
    //       this.gestoresArray = data?.datos ?? [];
    //       this.searchDone = true;
    //       this.dataForm.get('gestor')?.setValue(null);
    //       this.dataForm.get('gestor')?.enable();
    //       if (this.gestoresArray.length === 0) {
    //         this.snackBarSrv.showSnackBar('No se encontraron gestores con ese documento', 'warning');
    //       }
    //     },
    //     error: () => {
    //       this.spinnerSrv.loadingHide();
    //       this.snackBarSrv.showSnackBar('Error al buscar gestores', 'error');
    //     },
    //   });


    
    const filtro: GestionResiduosFilterDTO = {
          codigoDocumento: documento.trim().toUpperCase(),
          gestorResiduos: true,
          gestoresResiduosEstado: {
            id: ['2'],
            // Solo gestores activos
          }
        };
    
        this.spinnerSrv.loadingShow();
        this.gestoresResiduosService.findAll8(filtro, { page: 0, size: 500, sort: [] }).subscribe({
          next: (data: any) => {
            this.spinnerSrv.loadingHide();

            this.gestoresArray = data?.datos ?? [];
    
            this.searchDone = true;
          this.dataForm.get('gestor')?.setValue(null);
         if (this.gestoresArray.length === 0) {
            this.snackBarSrv.showSnackBar('No se encontraron gestores', 'error');
          }
          },
          error: () => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar('Ha ocurrido un error al obtener gestores disponibles', 'error');
          },
        });
  }

  onGestorSeleccionado(gestor: GestoresResiduosDTO): void {
    if (gestor?.razonSocial) {
      this.dataForm.get('razonSocial')?.setValue(gestor.razonSocial);
    }
  }

  controlHasError(controlName: string, errorName: string): boolean {
    return (
      this.dataForm.controls[controlName].hasError(errorName) &&
      this.dataForm.controls[controlName].touched
    );
  }

  guardar(): void {
    this.dataForm.markAllAsTouched();
    this.dataForm.updateValueAndValidity();


    if (this.dataForm.valid) {
      const payload: AcuerdoIndirectoCreatePayloadDTO = {
        tipoDocumento: this.detectarTipoDocumento(this.dataForm.get('documento')?.value) ?? undefined,
        codigoDocumento: this.dataForm.get('documento')?.value,
        gestoresResiduos: this.dataForm.get('gestor')?.value,
        razonSocial: this.dataForm.get('razonSocial')?.value,
      };

      this.spinnerSrv.loadingShow();
      this.acuerdoIndirectoService.create2(payload).subscribe({
        next: (result) => {
          this.spinnerSrv.loadingHide();
          this.dialogRef.close(result);
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar('Error al guardar el acuerdo indirecto', 'error');
        },
      });
    } else {
      this.snackBarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.dataForm.get(formName)?.setValue(null);
  }

  showClearButton(formName: string): boolean {
    return this.dataForm.get(formName)?.value !== null;
  }

}
